import React from 'react';
import SelectList from 'app/Components/Shared/SelectList/SelectList';
import SongCard from '../../../Components/SongCard/SongCard';
import SongList from '../../../Components/SongList/SongList';
import SkeletonCard from '../../../Components/SkeletonCard/SkeletonCard';

/**
 * Renders the appropriate content based on the current mode
 */
export const SongsContent = ({
  isChangeDefaultSongFlow,
  isEditPlaylistFlow,
  showEmptyChangeDefaultMessage,
  showEmptyPlaylistMessage,
  songs,
  selectedSongId,
  onSongSelect,
  onSongClick,
  onPlayClick,
  onDownloadClick,
  isLoading,
  isAssignToContactFlow
}) => {
  if (isLoading && (isChangeDefaultSongFlow || isAssignToContactFlow)) {
    return (
      <div className='song-list loading'>
        {Array.from({ length: 6 }, (_, i) => (
          <div key={`skeleton-${i}`} className='song-list-item'>
            <SkeletonCard />
          </div>
        ))}
      </div>
    );
  }

  if (!isLoading && showEmptyChangeDefaultMessage) {
    return (
      <div className='empty-playlist-message'>
        <p>לא נמצאו שירים</p>
      </div>
    );
  }

  if (showEmptyPlaylistMessage) {
    return (
      <div className='empty-playlist-message'>
        <p>הפלייליסט שלך ריק כרגע</p>
        <p>הוסיפו שירים מהקטלוג כדי ליצור את הפלייליסט המושלם שלכם</p>
      </div>
    );
  }

  if (isChangeDefaultSongFlow || isAssignToContactFlow) {
    return (
      <SelectList
        options={songs.map((song) => ({
          key: song.productId || song.id,
          value: song.productId || song.id,
          song: song,
        }))}
        onClick={onSongSelect}
        hideRadioButtons={false}
        defaultValue={selectedSongId}
        renderItem={({ option, isSelected }) => (
          <SongCard
            song={{
              id: option.song.id || option.song.productId,
              description: option.song.description || option.song.title,
              author: option.song.author || option.song.artist || option.song.artistName,
              duration: option.song.duration,
              image: option.song.image || option.song.albumArt
            }}
            isSelected={isSelected}
            showMenu={false}
            disableHover={false}
          />
        )}
      />
    );
  }

  return (
    <SongList
      songs={songs}
      onSongClick={onSongClick}
      onPlayClick={onPlayClick}
      onDownloadClick={onDownloadClick}
      isLoading={isLoading}
    />
  );
};
